<template>
  <div class="bg_gray">
    <!-- 查询条件 -->
    <div class="query_well">
      <van-tabs v-model:active="tabType" type="card" color="#f1f1f1" title-inactive-color="#666" @change="changeQuery">
        <van-tab title="证书编号" name="certificate"></van-tab>
        <van-tab title="身份证号" name="id_no"></van-tab>
      </van-tabs>
      <van-form v-if="tabType == 'id_no'" @submit="certificateQuery('applyForm_1')" ref="applyForm_1">
        <van-cell-group inset>
          <van-field
            v-model="queryForm.id_no"
            center
            placeholder="请输入身份证号"
            :rules="rules.id_no"
            :formatter="formatter1"
          >
            <template #button>
              <van-button type="primary" native-type="submit">查询</van-button>
            </template>
          </van-field>
        </van-cell-group>
      </van-form>
      <van-form v-if="tabType == 'certificate'" @submit="certificateQuery('applyForm_2')" ref="applyForm_2">
        <van-cell-group inset>
          <van-field
            v-model="queryForm.certificate"
            center
            placeholder="请输入证书编号"
            :rules="rules.certificate"
            v-if="tabType == 'certificate'"
            :formatter="formatter1"
          >
            <template #button>
              <van-button type="primary" native-type="submit">查询</van-button>
            </template>
          </van-field>
        </van-cell-group>
      </van-form>
    </div>
    <!-- 查询结果 -->
    <div class="container">
      <template v-if="certList_total > 0">
        <div class="tip">已查询到<span>{{certList_total}}</span>项证书。</div>
        <div class="cert_item_common" v-for="item in certList" :key="item.id">
          <h3 class="text_ellipsis" :title="item.certificate.name">{{ item.certificate.name }}</h3>
          <p>姓名：{{ item.real_name }}</p>
          <p>身份证号：{{ item.identity_no }}</p>
          <p>证书编号：{{ item.serial_no }}</p>
          <p>发证日期：{{ item.created_at }}</p>
        </div>
      </template>
      <van-empty v-if="certList_total == 0 && first == false" description="抱歉，未查询到相关证书"/>
    </div>
  </div>
</template>

<script>
  import { checkCertificate } from 'api/certificate/detail'
  import { checkIDCardNo, checkcertificateNum } from 'utils/mobile/common'
  export default {
    components: {
    },
    data() {
      return {
        first: true,
        tabType: 'certificate',
        queryForm: {
          id_no: '',
          certificate:''
        },
        certList: [],
        certList_total:'',
        rules:{
          id_no: [
            {required: true, message: '请输入身份证号', trigger: 'onBlur'},
            {required: true, validator: checkIDCardNo, trigger: 'onBlur'},
          ],
          certificate: [
            {required: true, message: '请输入证书编号', trigger: 'onBlur'},
            {required: true, validator: checkcertificateNum, trigger: 'onBlur'},
          ],
        }
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      changeQuery(name) {
        if(name === 'certificate') {
          this.queryForm.id_no = ''
          this.certList = []
          this.first = true
          this.certList_total = ''
        } else {
          this.queryForm.certificate = ''
          this.certList = []
          this.first = true
          this.certList_total = ''
        }
      },
      certificateQuery(formName){
        this.$refs[formName].validate().then(() => {
          const filters = {
              'certificate':this.queryForm.certificate,
              'id_no':this.queryForm.id_no}
          this.loading = true
          checkCertificate(filters).then((result) => {
            this.certList = []
            this.certList_total = ''
            this.first = false
            this.loading = false
            if(result.success == true){
              var data = result.data
              this.certList.push(...data)
              this.certList_total = result.total
            }else{
              this.certList = []
              this.certList_total = 0
            }
          })
        }).catch(err => {
        });
      },
      formatter1(value) {
        // 过滤空格
        return value.replace(/^ +| +$/g, '');
      },
    }
  };
</script>

<style lang="scss" scoped>
  .query_well {
    background:#fff;
    padding-bottom:20px;
  }
  :deep(.van-tabs) {
    display:inline-flex;
    margin-top:15px;
    margin-bottom:15px;
    .van-tabs__wrap {
      height:auto;
      .van-tabs__nav--card {
        height:auto;
        border-radius: 4px;
        overflow:hidden;
      }
    }
    .van-tab {
      padding:10px 25px;
      &.van-tab--active {
        background-color:#00adef !important;
        border-color:#00adef !important;
      }
    }
  }
  :deep(.van-cell-group) {
    border-radius:0;
    .van-cell {
      padding:0;
    }
    .van-field__control {
      height:34px;
      background: #f3f3f3;
      padding:0 10px;
      border-radius: 2px;
      color:#666;
    }
  }
  .container {
    background:transparent;
  }
  .tip {
    margin-bottom:20px;
    > span {
      color:#ff6600;
      margin-left:2px;
      margin-right:2px;
    }
  }
</style>
